module.exports = {
    title: 'Portfolio',
    subtitle: "A list of the most remarkable projects I've worked on",
};



// WEBPACK FOOTER //
// ./content/pages/portfolio.js